<template>
    <div id="app">
        <layout></layout>
    </div>
</template>

<script>
import layout from "@/layouts/layout";
import ogImage from '@/assets/icons/logo.svg';

export default {
    name: 'App',
    metaInfo: {
        title: 'Кадастр UA - кадастрова карта земельних ділянок',
        meta: [
            {
                'name': 'description',
                'content': 'Кадастрова карта України. Відомості про земельні ділянки. Пошук ділянок за кадастровим номером.',
            },
            {
                'property': 'og:url',
                'content': window.location.origin,
            },
            {
                'property': 'og:type',
                'content': 'website',
            },
            {
                'property': 'og:title',
                'content': 'Кадастр UA - кадастрова карта земельних ділянок',
            },
            {
                'property': 'og:description',
                'content': 'Кадастрова карта України. Відомості про земельні ділянки. Пошук ділянок за кадастровим номером.',
            },
            {
                'property': 'og:image',
                'content': window.location.origin + '/' + ogImage,
            }
        ]
    },
    components: {
        layout,
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
</style>
